<template>
  <div class="reward-trans-image" :class="{ compact }" :style="rootStyle">
    <img class="bg" :src="bg" alt="" />
    <img class="reward" :src="rewardIcon" :alt="alt" v-if="rewardIcon" />
    <div class="qty" :style="quantityStyle" v-if="quantity">{{ quantityLabel }}</div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { IRewardTransQuantity } from '../models/reward'
import { buildRewardTransQuantityLabel } from '../service/rewardTransService'

const props = withDefaults(
  defineProps<{
    bg: string
    rewardIcon: string
    alt?: string
    size?: number
    compact?: boolean
    quantity?: IRewardTransQuantity | null
  }>(),
  {
    alt: '',
    size: 180,
    compact: false,
    quantity: null,
  }
)

const designSize = 180

const rootStyle = computed(() => {
  const scale = props.size / designSize

  return {
    width: `${props.size / 12}rem`,
    height: `${props.size / 12}rem`,
    '--scale': `${scale}`,
  }
})

const quantityStyle = computed(() => props.quantity?.style || {})

const quantityLabel = computed(() => (props.quantity ? buildRewardTransQuantityLabel(props.quantity) : ''))
</script>

<style lang="less">
.reward-trans-image {
  position: relative;
  flex: none;
  overflow: hidden;

  > .bg {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  > .reward {
    position: absolute;
    top: calc(4px * var(--scale));
    left: calc(3px * var(--scale));
    width: calc(88px * var(--scale));
    height: calc(88px * var(--scale));
    object-fit: contain;
  }

  > .qty {
    position: absolute;
    right: 0;
    bottom: 0;
    line-height: calc(52px * var(--scale));
    font-size: calc(38px * var(--scale));
    font-weight: 900;
    font-family: 'nunito_bold';
    color: #fff;
    text-shadow: calc(1px * var(--scale)) calc(1px * var(--scale)) #743816,
      calc(-1px * var(--scale)) calc(1px * var(--scale)) #743816,
      calc(-1px * var(--scale)) calc(-1px * var(--scale)) #743816,
      calc(1px * var(--scale)) calc(-1px * var(--scale)) #743816;
    pointer-events: none;
  }

  &.compact {
    > .qty {
      bottom: calc(4px * var(--scale));
      line-height: calc(28px * var(--scale));
      font-size: calc(20px * var(--scale));
    }
  }
}
</style>
